module.exports = __webpack_public_path__ + "img/10.06378d15.png";